import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { AlertContent, Container, CardContent, CardBody, CardTitle, CustomAlertText } from './filter-carplate-menu.styles';
import { ALERT_ICONS, DEFAULT_ALERT_CONTENT, PROPTYPES, DEFAULT_PROPS } from './filter-carplate-menu.constrants';

const getAlertDetails = ({
  message,
  type
}) => {
  const icon = ALERT_ICONS[type];
  if (!message || !icon) return null;
  return {
    message,
    type,
    icon
  };
};

const renderAlertContent = alertDetails => {
  if (!alertDetails) return null;
  return /*#__PURE__*/React.createElement(AlertContent, {
    "data-testid": "alert-content"
  }, /*#__PURE__*/React.createElement(CustomAlertText, {
    message: {
      text: alertDetails.message
    },
    icon: alertDetails.icon,
    type: alertDetails.type
  }));
};

const FilterCarplateMenu = _ref => {
  let {
    title,
    children,
    alertContent,
    withBorder
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "children", "alertContent", "withBorder"]);

  const alertDetails = getAlertDetails(alertContent || DEFAULT_ALERT_CONTENT);
  if (!title && !children) return null;
  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "card",
    withBorder: withBorder
  }, props), renderAlertContent(alertDetails), /*#__PURE__*/React.createElement(CardContent, {
    isAlert: Boolean(alertDetails)
  }, title && /*#__PURE__*/React.createElement(CardTitle, {
    "data-testid": "card-title"
  }, title), children && /*#__PURE__*/React.createElement(CardBody, {
    "data-testid": "card-content",
    isRow: props.isRow
  }, children)));
};

process.env.NODE_ENV !== "production" ? FilterCarplateMenu.propTypes = PROPTYPES : void 0;
FilterCarplateMenu.defaultProps = DEFAULT_PROPS;
export default FilterCarplateMenu;